
<template>
   <v-dialog
      v-model="showHelp"
      max-width="490" 
    >
      <v-card class="pb-3">
        <v-toolbar color="green darken-3" dark>
        <v-toolbar-title class="headline">About Room Amenities</v-toolbar-title>
      </v-toolbar>

        <v-card-text class="ml-2 mt-3">
          Room Amenities can create and track user-defined room attributes for any room.<br><br>


        <b>Creating a List </b>
          <ul>
          <li>Create an Amenity List.</li>
          <li>Assign editors to help gather data.</li>
          <li>Add attributes and define their data types.</li>
          <li>Save list.</li>
          </ul><br>

        <b>Collecting Data</b>
          <ul>
            <li>Select a room in Interactive Floorplans</li>
            <li>In sidepanel, click <v-icon>grading</v-icon> in toolbar for Room Amenities.</li>
            <li>Select an Amenity List.</li>
            <li>'Populate' List to begin.</li>
            <li>Record data for this room.</li>
          </ul>
        <br>
          <b>Search</b> for rooms by their Room Amenities<br> 
          <ul><li>Menu > Search > Rooms > Amenities</li></ul>
        <br>
          <b>Export</b> all the data<br> 
          <ul><li>Menu for the List Definition</li></ul>
          <br>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-layout align-items-center>
          <v-btn color="green darken-1"
            flat="flat"
            @click.stop="setShowHelpRoomAmenities2(false)"
          > OK
          </v-btn>
      </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>

</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HelpRoomAmenities',

  computed: {
      showHelp: {
          get () { return this.$store.state.ui.showHelpRoomAmenities2 },
          set (value) { this.setShowHelpRoomAmenities2(false) }
      },
  },
  
  methods : {
      ...mapMutations(['setShowHelpRoomAmenities2',]),
  },
}

</script>





// WEBPACK FOOTER //
// src/components/help/HelpRoomAmenities2.vue